// extracted by mini-css-extract-plugin
module.exports = {"projectWrapper":"project_projectWrapper__wCEwN","projectBackground":"project_projectBackground__3TRUL","projectTop":"project_projectTop__2z11J"};